import { TaskParameterModel } from "@/components/task-parameter/models";
import { ResponseModel } from "@/models";
import { ITaskParameters } from "../ITaskParameters";
import ApiService from "@/api";
import { SendErrorNotification } from "../functions";
import UpdateQueueTaskStatusRequest from "@/api/Main/dataSource/api/projects/task/i-service/models/status/UpdateQueueTaskStatusRequest";
import UpdateQueueTaskStatusRequestItem from "@/api/Main/dataSource/api/projects/task/i-service/models/status/UpdateQueueTaskStatusRequestItem";
import GetListStatusRequest from "@/api/Main/dataSource/api/projects/task/i-service/models/status/GetListStatusRequest";

/**Сервис для управления статусами */
export class TaskStatusesServiceAdapter implements ITaskParameters {
  /**Сервис для использования API */
  api = new ApiService();

  async GetList(
    entityId: string | number | string[],
    currentNamespace: string,
  ): Promise<ResponseModel<TaskParameterModel[]>> {
    const result = new ResponseModel<TaskParameterModel[]>();

    const idsArray = Array.isArray(entityId) ? entityId : [String(entityId)];
    try {
      const response = await this.api.Main.TaskStatusListService.getListAsync(new GetListStatusRequest({
        QueueTasksId: idsArray,
        OrderByName: undefined,
        GlobalStatusIds: [],
        Search: "",
      }));
      result.Value = response.Items.map(
        (x) =>
          new TaskParameterModel({
            Id: x.Id,
            Color: x.Color,
            Name: x.Name,
            IsDefault: x.IsDefault,
            InUse: x.InUse,
            QueueId: x.QueueTaskId,
            OrganizationGlobalStatus: x.OrganizationGlobalStatus,
            NamespaceId: currentNamespace,
            Description: x.Description,
          }),
      );
    } catch (e) {
      result.IsSuccess = false;
      result.ErrorCode = e?.ErrorCode;
      result.ErrorMessage = e?.ErrorMessage;
      SendErrorNotification(result.ErrorMessage);
      console.error("ERROR updateQueueTaskEmployeeRoleList", e);
    }

    return result;
  }
  SetList(
    entityId: string,
    parameters: TaskParameterModel[],
  ): Promise<ResponseModel<TaskParameterModel[]>> {
    return new Promise<ResponseModel<TaskParameterModel[]>>(async (resolve) => {
      const result = new ResponseModel<TaskParameterModel[]>();

      await this.api.Main.TaskStatusSaveService.updateQueueTaskStatusAsync(
        new UpdateQueueTaskStatusRequest({
          QueueTaskId: entityId,
          Statuses: parameters.map(
            (x) =>
              new UpdateQueueTaskStatusRequestItem({
                StatusId: x.Id as number,
                Name: x.Name,
                Color: x.Color,
                IsDefault: x.IsDefault,
                OrganizationStatusId: x.OrganizationGlobalStatus?.Id as any,
                Description: x.Description,
              }),
          ),
        }),
      )
        .then((response) => {
          result.Value = response.Items.map(
            (p) =>
              new TaskParameterModel({
                Id: p.StatusId,
                Name: p.Name,
                Color: p.Color,
                IsDefault: p.IsDefault,
                InUse: (p as any).InUse,
                Description: p.Description,
              }),
          );
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          SendErrorNotification(result.ErrorMessage);
          console.error("ERROR updateQueueTaskEmployeeRoleList", e);
          return resolve(result);
        });
    });
  }
  /**
   * Получение глобальных стстусов
   * @param entityId
   * @returns
   */
  async getGlobalStatusList(): Promise<ResponseModel<TaskParameterModel[]>> {
    const result = new ResponseModel<TaskParameterModel[]>();
    try {
      const response = await this.api.Main.TaskStatusListService.getGlobalStatusesAsync();
      result.Value = response.Items.map(
        (x) =>
          new TaskParameterModel({
            Id: x.Id,
            Color: x.Color,
            Name: x.Name,
            IsDefault: false,
            InUse: false,
          }),
      );
    } catch (e) {
      result.IsSuccess = false;
      result.ErrorCode = e?.ErrorCode;
      result.ErrorMessage = e?.ErrorMessage;
      SendErrorNotification(result.ErrorMessage);
      console.error("ERROR get Global statuss", e);
    }

    return result;
  }
}
